/**
 * 模块: KeywordTrendPivotTab
 * 职责: 关键词趋势透视表Tab主组件
 * 限制: <280行
 */

import React, { useMemo } from 'react';
import { Table, Spin, Empty } from 'antd';
import { buildPivotColumns } from './columnBuilder';
import type { PivotTableData } from './types';

interface KeywordTrendPivotTabProps {
  data: PivotTableData | null;
  loading: boolean;
}

/**
 * 关键词趋势透视表Tab组件
 */
export const KeywordTrendPivotTab: React.FC<KeywordTrendPivotTabProps> = ({
  data,
  loading,
}) => {
  console.log('[KeywordTrendPivotTab] 接收到的数据:', { 
    data, 
    loading, 
    dataType: typeof data, 
    dataKeys: data ? Object.keys(data) : null,
    periodsCount: data?.periods?.length,
    keywordsCount: data?.keywords?.length,
    firstKeyword: data?.keywords?.[0]
  });

  // 生成动态列
  const columns = useMemo(() => buildPivotColumns(data), [data]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" tip="加载关键词趋势数据..." />
      </div>
    );
  }

  if (!data || data.keywords.length === 0) {
    return (
      <Empty
        description="暂无数据"
        style={{ padding: '50px' }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <div style={{ padding: '16px' }}>
      <div style={{ marginBottom: '16px', fontSize: '14px', color: '#8c8c8c' }}>
        共 <strong style={{ color: '#1890ff' }}>{data.total_keywords}</strong> 个关键词，
        <strong style={{ color: '#52c41a' }}>{data.periods.length}</strong> 个周期的数据对比
      </div>

      <Table
        columns={columns}
        dataSource={data.keywords}
        rowKey="search_query"
        scroll={{ x: 300 + data.periods.length * 400, y: 600 }}
        sticky={{ offsetHeader: 0 }}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 个关键词`,
          pageSizeOptions: ['20', '50', '100', '200'],
        }}
        bordered
        size="small"
      />
    </div>
  );
};

